'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateAccountAddresses = function TemplateAccountAddresses(template) {
  var _this = this;

  (0, _classCallCheck3.default)(this, TemplateAccountAddresses);

  this.el = template.el;
  this.countryProvinceSelectors = [];

  this.countryProvinceSelector = new Shopify.CountryProvinceSelector('address-country', 'address-province', {
    hideElement: 'address-province-container'
  });

  var addresses = this.el.querySelectorAll('[id^=address-country-]');

  addresses.forEach(function (address) {
    var addressId = address.id.split('-')[2];

    _this.countryProvinceSelectors.push(new Shopify.CountryProvinceSelector('address-country-' + addressId, 'address-province-' + addressId, {
      hideElement: 'address-province-container-' + addressId
    }));
  });
};

exports.default = TemplateAccountAddresses;